import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';

import { getPreviewService } from 'services/pages';
import { DEFAULT_QUERY_OPTION } from 'utils/constants';

function usePreviewQuery<T, P>(
  name: string,
  service: (...arg: any) => Promise<T>,
  dep?: any,
  enabled?: boolean,
): {
  isLoading: boolean;
  data?: P | T;
  error: unknown;
} {
  const { search } = useLocation();
  const param = new URLSearchParams(search);

  const { isFetching: isLoading, data, error } = useQuery([name, dep], () => service(), {
    ...DEFAULT_QUERY_OPTION,
    enabled: (!param.get('preview') && enabled) ?? !param.get('preview'),
  });

  const { isLoading: isLoadingPreview, data: dataPreview, error: errorPreview } = useQuery(
    [`${name}-preview`, dep],
    () => getPreviewService<P>(param.get('preview') || ''),
    {
      ...DEFAULT_QUERY_OPTION,
      enabled: (!!param.get('preview') && enabled) ?? !!param.get('preview'),
    },
  );

  return {
    isLoading: isLoadingPreview || isLoading,
    data: dataPreview || data,
    error: errorPreview || error,
  };
}

export default usePreviewQuery;
